import { inject, Injectable } from "@angular/core";
import { HttpService } from "../../core/services";

@Injectable({
  providedIn: 'root'
})
export class CalendarApi {
  private readonly httpService = inject(HttpService);

  listEvents(start: string, end: string) {
    const query = new URLSearchParams({ start, end }).toString();
    return this.httpService.get(`calendar/events?${query}`, false);
  }

  createEvent(payload: any) {
    return this.httpService.post('calendar/events', payload, false);
  }

  updateEvent(eventId: string, payload: any) {
    return this.httpService.put(`calendar/events/${eventId}`, payload, false);
  }

  deleteEvent(eventId: string) {
    return this.httpService.delete(`calendar/events/${eventId}`, false);
  }

  joinMeetrixByToken(token: string) {
    const safe = encodeURIComponent(token.trim());
    return this.httpService.get(`calendar/join/${safe}/launch`, true);
  }

  inviteParticipant(eventId: string, payload: { name?: string; email: string }) {
    return this.httpService.post(`calendar/events/${eventId}/invite`, payload, false);
  }

  joinMeeting(eventId: string) {
    return this.httpService.get(`calendar/events/${eventId}/join_meeting`, true);
  }
}
